import { render, staticRenderFns } from "./Recover1.vue?vue&type=template&id=3139590d&scoped=true&"
import script from "./Recover1.vue?vue&type=script&lang=js&"
export * from "./Recover1.vue?vue&type=script&lang=js&"
import style0 from "./Recover1.vue?vue&type=style&index=0&id=3139590d&lang=less&scoped=true&"
import style1 from "./Recover1.vue?vue&type=style&index=1&id=3139590d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3139590d",
  null
  
)

export default component.exports